import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button/Button';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { StepContent } from '../styled';

export default function SuccessStep() {
  return (
    <StepContent>
      <Typography variant="h3">Sua solicitação foi enviada!</Typography>

      <Typography variant="body2R">
        Lembrando que nossas médicas têm até <b>7 dias úteis</b> para visualizar e o retorno sobre o seu pedido será enviado
        para o e-mail cadastrado aqui na Oya. Caso tenha alguma dúvida, entre em contato.
      </Typography>

      <Button
        variant="inline"
        color="primary"
        href={process.env.REACT_APP_WHATSAPP}
        target="_blank"
        component="a"
        sx={{ display: 'inline-flex' }}
        endIcon={<WhatsAppIcon />}
      >
        Falar com Equipe de Cuidados
      </Button>
    </StepContent>
  );
}
